import { render, staticRenderFns } from "./PathStructure.vue?vue&type=template&id=6b05ce4e&scoped=true&"
import script from "./PathStructure.vue?vue&type=script&lang=js&"
export * from "./PathStructure.vue?vue&type=script&lang=js&"
import style0 from "./PathStructure.vue?vue&type=style&index=0&id=6b05ce4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05ce4e",
  null
  
)

export default component.exports